export const DEFAULT_EDITOR_TEST_IDS = {
  root: 'content-blocks-editor-root',
  toolbar: 'content-blocks-editor-toolbar',
  slashMenu: 'content-blocks-editor-slash-menu',
  blockActions: 'content-blocks-editor-block-actions',
  blockMenu: 'content-blocks-editor-block-menu',
} as const

